import React from 'react'

import { cn } from '@/shared/lib/utils'

export const DescriptionList = ({
	className,
	...props
}: React.ComponentPropsWithoutRef<'dl'>) => (
	<dl className={cn('grid gap-4', className)} {...props} />
)

export const DescriptionTerm = ({
	className,
	...props
}: React.HTMLAttributes<HTMLElement>) => (
	<dt
		className={cn(
			'font-nomal text-sm leading-none tracking-tight text-muted-foreground',
			className
		)}
		{...props}
	/>
)

export const DescriptionDetail = ({
	className,
	...props
}: React.HTMLAttributes<HTMLElement>) => (
	<dd className={cn('text-sm', className)} {...props} />
)

export const DescriptionGroup = ({
	className,
	...props
}: React.HTMLAttributes<HTMLElement>) => (
	<div className={cn('grid gap-1', className)} {...props} />
)
